/*=========================================================================================
  File Name: moduleDeviceMutations.js
  Description: Device Module Mutations
==========================================================================================*/
import * as _ from "lodash";
export default {
	SET_DEVICES_SEARCH_QUERY(state, query) {
		state.devicesSearchQuery = query;
	},
	UPDATE_DEVICES_FILTER(state, filter) {
		state.devicesFilter = filter;
	},

	// API
	SET_DEVICES(state, devices) {
		state.devices = devices;
	},

	SET_IS_FETCHED_DEVICES(state, isFetchedDevices) {
		state.isFetchedDevices = isFetchedDevices;
	},

	ADD_DEVICE(state, device) {
		state.devices.unshift(device);
	},

	SET_DEVICES_STATUS(state, status) {
		state.devicesStatus = status;
	},

	UPDATE_DEVICE(state, device) {
		const deviceIndex = state.devices.findIndex(t => t.id === device.id);
		if (deviceIndex && deviceIndex != -1) {
			Object.assign(state.devices[deviceIndex], device);
		}
	},

	SET_TOTAL_DEVICES(state, totalDevices) {
		state.totalDevices = totalDevices;
	},

	DELETE_DEVICE(state, deviceId) {
		const deviceIndex = state.devices.findIndex(t => t.id == deviceId);
		state.devices.splice(deviceIndex, 1);
	},

	SET_KPI_DETAILS(state, kpiDetails) {
		state.kpiDetails = kpiDetails;
	},

	ADD_KPI_DETAIL(state, kpiDetail) {
		state.kpiDetails.push(kpiDetail);
	},

	UPDATE_KPI_DETAIL(state, kpiDetail) {
		const kpiDetailIndex = state.kpiDetails.findIndex(t => t.pivot_id === kpiDetail.pivot_id);
		Object.assign(state.kpiDetails[kpiDetailIndex], kpiDetail);
	},

	DELETE_KPI_DETAIL(state, kpiDetailId) {
		const kpiDetailIndex = state.kpiDetails.findIndex(t => t.pivot_id == kpiDetailId);
		state.kpiDetails.splice(kpiDetailIndex, 1);
	},

	SET_CATEGORIES(state, categories) {
		state.categories = categories;
	},

	ADD_CATEGORY(state, category) {
		state.categories.push(category);
	},

	UPDATE_CATEGORY(state, category) {
		const categoryIndex = state.categories.findIndex(t => t.id === category.id);
		Object.assign(state.categories[categoryIndex], category);
	},

	DELETE_CATEGORY(state, categoryId) {
		const categoryIndex = state.categories.findIndex(t => t.id == categoryId);
		state.categories.splice(categoryIndex, 1);
	},

	SET_INVENTORIES(state, inventories) {
		state.inventories = inventories;
	},

	ADD_INVENTORY(state, inventory) {
		state.inventories.push(inventory);
	},

	UPDATE_INVENTORY(state, inventory) {
		const inventoryIndex = state.inventories.findIndex(t => t.id === inventory.id);
		Object.assign(state.inventories[inventoryIndex], inventory);
	},

	DELETE_INVENTORY(state, inventoryId) {
		const inventoryIndex = state.inventories.findIndex(t => t.id == inventoryId);
		state.inventories.splice(inventoryIndex, 1);
	},

	SET_ACCESSORIES(state, accessories) {
		state.accessories = _.unionBy(state.accessories, accessories, "id");
	},
	SET_MATERIAL(state, material) {
		state.material = _.unionBy(state.material, material, "id");
	},
	SET_KPI_V2(state, kpi) {
		state.kpi = _.unionBy(state.kpi, kpi, "id");
	},
	ADD_ACCESSORY(state, accessory) {
		state.accessories.unshift(accessory);
	},

	ADD_MATERIAL(state, material) {
		state.material.unshift(material);
	},

	ADD_KPI(state, remind) {
		state.kpi.unshift(remind);
	},

	UPDATE_ACCESSORY(state, accessory) {
		const accessoryIndex = state.accessories.findIndex(t => t.id === accessory.id);
		if (accessoryIndex !== -1) Object.assign(state.accessories[accessoryIndex], accessory);
	},

	UPDATE_MATERIAL(state, material) {
		const materialIndex = state.material.findIndex(t => t.id === material.id);
		if (materialIndex !== -1) Object.assign(state.material[materialIndex], material);
	},

	UPDATE_KPI(state, work) {
		const workIndex = state.kpi.findIndex(t => t.id === work.id);
		if (workIndex !== -1) Object.assign(state.kpi[workIndex], work);
	},

	DELETE_ACCESSORY(state, accessoryId) {
		const accessoryIndex = state.accessories.findIndex(t => t.id == accessoryId);
		if (accessoryIndex != -1) state.accessories.splice(accessoryIndex, 1);
	},
	DELETE_MATERIAL(state, accessoryId) {
		const accessoryIndex = state.material.findIndex(t => t.id == accessoryId);
		if (accessoryIndex != -1) state.material.splice(accessoryIndex, 1);
	},
	DELETE_KPI(state, accessoryId) {
		const accessoryIndex = state.kpi.findIndex(t => t.id == accessoryId);
		if (accessoryIndex != -1) state.kpi.splice(accessoryIndex, 1);
	},
	RESET_ACCESSORIES(state) {
		state.accessories = [];
		state.material = [];
		state.kpi = [];
		state.totalAccessories = 0;
		state.totalMaterial = 0;
		state.totalKpi = 1;
	},

	SET_TOTAL_ACCESSORIES(state, total) {
		state.totalAccessories = total;
	},
	SET_TOTAL_MATERIAL(state, total) {
		state.totalMaterial = total;
	},
	SET_TOTAL_KPI(state, total) {
		state.totalKpi = total;
	},
	SET_TOTAL_KPI_DETAILS(state, total) {
		state.totalKpiDetails = total;
	},

	// REDUCTION

	REDUCTION_TOTAL_ACCESSORIES(state) {
		state.totalAccessories = state.totalAccessories - 1;
	},
	REDUCTION_TOTAL_MATERIAL(state) {
		state.totalMaterial = state.totalMaterial - 1;
	},
	REDUCTION_TOTAL_KPI(state) {
		state.totalKpi = state.totalKpi - 1;
	},
	REDUCTION_TOTAL_KPI_DETAILS(state) {
		state.totalKpiDetails = state.totalKpiDetails - 1;
	},
	// INCREASE
	INCREASE_TOTAL_ACCESSORIES(state) {
		state.totalAccessories = state.totalAccessories + 1;
	},
	INCREASE_TOTAL_MATERIAL(state) {
		state.totalMaterial = state.totalMaterial + 1;
	},
	INCREASE_TOTAL_KPI(state) {
		state.totalKpi = state.totalKpi + 1;
	},
	INCREASE_TOTAL_KPI_DETAIL(state) {
		state.totalKpiDetails = state.totalKpiDetails + 1;
	},

	// Logs Todo
	SET_LOGS_CURRENT_TODO(state, todos) {
		state.logsCurrentTodo = todos;
	},
	SET_LOGS_DONE_TODO(state, todos) {
		state.logsDoneTodo = todos;
	},
	SET_TOTAL_LOGS_CURRENT_TODO(state, total) {
		state.totalLogsCurrentTodo = total;
	},
	SET_TOTAL_LOGS_DONE_TODO(state, total) {
		state.totalLogsDoneTodo = total;
	},
	// Logs request
	SET_LOGS_REQUEST_BY_DEVICE(state, requests) {
		state.requestsByDevice = requests;
	},
	SET_TOTAL_LOGS_REQUEST_BY_DEVICE(state, total) {
		state.totalRequestsByDevice = total;
	}
};
